import React from 'react'
import { Flex, Box } from 'components'
import { height, color } from 'styled-system'
import styled, { keyframes } from 'styled-components'

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

const LoaderWrap = Flex.extend`
  align-items: center;
  justify-content: center;
  ${height}
  ${color}
`

LoaderWrap.defaultProps = {
  height: 14,
}

const DURATION = 0.5

const Dot = styled.circle`
  animation: ${props => props.duration}s ease-in-out ${props => `${props.delay}s`} infinite alternate-reverse ${fadeIn};
  fill: currentColor;
`

Dot.defaultProps = {
  duration: DURATION,
  delay: 0,
  r: 50,
}

const Loader = ({
  radius=42, gutter=60, size=14, ...rest
}) => (
  <LoaderWrap {...rest}>
    <svg style={{ display: 'block' }} viewBox={`0 0 ${radius * 6 + gutter * 2} 100`} height={size} xmlns="http://www.w3.org/2000/svg">
      <Dot cx={radius} cy={radius} r={radius} />
      <Dot delay={DURATION * 0.333} cx={radius * 3 + gutter} cy={radius} r={radius} />
      <Dot delay={DURATION * 0.666} cx={radius * 5 + gutter * 2} cy={radius} r={radius} />
    </svg>
  </LoaderWrap>
)

export default Loader



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Loader.js